import type { ComponentChildren } from 'preact';

/**
 * Centered page container with standard gutter + vertical padding. Two caps:
 *
 *   • `readable` (default, max-w-7xl ≈ 1280px) - for prose-heavy surfaces.
 *   • `wide` (max-w-[1680px]) - matches the platform navbar's cap so chrome columns line up.
 */
export function PageContainer({
  cap = 'readable',
  pad = true,
  children,
  class: extraClass,
}: {
  cap?: 'readable' | 'wide';
  pad?: boolean;
  children: ComponentChildren;
  class?: string;
}) {
  const maxWidth = cap === 'wide' ? 'max-w-[1680px]' : 'max-w-7xl';
  const gutter = cap === 'wide' ? 'px-[clamp(20px,3.5vw,56px)]' : 'px-6';
  const padding = pad ? 'py-8' : '';
  return (
    <div class={`mx-auto w-full ${maxWidth} ${gutter} ${padding} ${extraClass ?? ''}`}>
      {children}
    </div>
  );
}
